import * as $ from 'jquery'
declare var jQuery: any;

import './semantic/definitions/modules/transition.js'
import './semantic/definitions/modules/dropdown.js'
import './semantic/definitions/modules/progress.js'
import './semantic/definitions/modules/accordion.js'
import './semantic/definitions/modules/checkbox.js'
import './semantic/definitions/modules/search.js'
import './semantic/definitions/behaviors/api.js'

import * as Sugar from 'sugar'

// TODO: find-out why calling 'ng test' will make simple 'Sugar.extend()' fail with this error:
// 'Uncaught TypeError: Sugar.extend is not a function'
Sugar.Object.extend()
Sugar.Array.extend()
Sugar.Date.extend()
Sugar.Function.extend()
Sugar.Number.extend()
Sugar.RegExp.extend()
Sugar.String.extend()

import { AngularSvgIconModule } from 'angular-svg-icon'

import { ButtonGroupComponent } from './components/button-group/button-group.component'
import { ColorPickerComponent } from './components/color-picker/color-picker.component'
import { DropdownComponent } from './components/dropdown/dropdown.component'
import { MultipleSelectDropdownComponent } from './components/multiple-select-dropdown/multiple-select-dropdown.component'
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component'
import { ProgressLineComponent } from './components/progress-line/progress-line.component'
import { LogoComponent } from './components/burt-logo/burt-logo.component'
import { DaterangePickerComponent } from './components/daterange-picker/daterange-picker.component'
import { DatePickerComponent } from './components/date-picker/date-picker.component'
import { ToggleComponent } from './components/toggle/toggle.component'

import { DropdownMenuDirective } from './directives/dropdown-menu/dropdown-menu.directive'

import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'

export { DropdownComponent } from './components/dropdown/dropdown.component'

const BURT_UI_COMPONENTS = [
  ButtonGroupComponent,
  ColorPickerComponent,
  DropdownComponent,
  MultipleSelectDropdownComponent,
  ProgressBarComponent,
  ProgressLineComponent,
  LogoComponent,
  DaterangePickerComponent,
  DatePickerComponent,
  ToggleComponent
]

const BURT_UI_DIRECTIVES = [
  DropdownMenuDirective,
]

const BURT_UI_MODULES = [
  CommonModule,
  FormsModule,
  // HttpModule,
  HttpClientModule,
  ReactiveFormsModule,
  RouterModule,
  AngularSvgIconModule
]

@NgModule({
  declarations: [ BURT_UI_COMPONENTS, BURT_UI_DIRECTIVES ],
  exports: [ BURT_UI_COMPONENTS, BURT_UI_DIRECTIVES, BURT_UI_MODULES ],
  imports: [ BURT_UI_MODULES ],
})
export class BurtUiModule {}
